import React from 'react';

/**
 * Categorias disponíveis no Catálogo 2D
 */
export const CATALOG_CATEGORIES = [
  'ALL',
  'Cozinha',
  'Gourmet',
  'Lavanderia',
  'Sala',
  'Quarto',
  'Banheiro',
  'Escritório',
  'Módulos'
];

/**
 * Catálogo Técnico 2D em Vista Superior (Top View / Planta Baixa)
 * Dimensões em centímetros (cm), correspondentes à escala 1:1 do mundo virtual do Croqui 2D.
 */
export const APPLIANCE_CATALOG = [
  // ==========================================
  // COZINHA
  // ==========================================
  {
    id: 'cooktop_4b',
    name: 'Cooktop 4 Bocas',
    category: 'Cozinha',
    defaultWidth: 60,
    defaultHeight: 52,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="50" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="5" width="50" height="42" rx="2" fill="none" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,2" />
      <circle cx="18" cy="16" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="18" cy="16" r="3" fill="${stroke}" />
      <circle cx="42" cy="16" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="42" cy="16" r="3" fill="${stroke}" />
      <circle cx="18" cy="36" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="18" cy="36" r="3" fill="${stroke}" />
      <circle cx="42" cy="36" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="42" cy="36" r="3" fill="${stroke}" />
      <circle cx="53" cy="16" r="1.5" fill="${stroke}" />
      <circle cx="53" cy="23" r="1.5" fill="${stroke}" />
      <circle cx="53" cy="30" r="1.5" fill="${stroke}" />
      <circle cx="53" cy="37" r="1.5" fill="${stroke}" />
    `
  },
  {
    id: 'cooktop_5b',
    name: 'Cooktop 5 Bocas',
    category: 'Cozinha',
    defaultWidth: 75,
    defaultHeight: 52,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="73" height="50" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="5" width="65" height="42" rx="2" fill="none" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,2" />
      <circle cx="37.5" cy="26" r="10" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="37.5" cy="26" r="4" fill="${stroke}" />
      <circle cx="16" cy="16" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="16" cy="16" r="2.5" fill="${stroke}" />
      <circle cx="59" cy="16" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="59" cy="16" r="2.5" fill="${stroke}" />
      <circle cx="16" cy="36" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="16" cy="36" r="2.5" fill="${stroke}" />
      <circle cx="59" cy="36" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="59" cy="36" r="2.5" fill="${stroke}" />
    `
  },
  {
    id: 'stove_4b',
    name: 'Fogão de Piso 4 Bocas',
    category: 'Cozinha',
    defaultWidth: 60,
    defaultHeight: 65,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="63" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="53" x2="59" y2="53" stroke="${stroke}" stroke-width="1.5" />
      <rect x="15" y="56" width="30" height="4" rx="1" fill="${stroke}" />
      <circle cx="18" cy="18" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="42" cy="18" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="18" cy="38" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="42" cy="38" r="7" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="10" cy="50" r="1.5" fill="${stroke}" />
      <circle cx="23" cy="50" r="1.5" fill="${stroke}" />
      <circle cx="37" cy="50" r="1.5" fill="${stroke}" />
      <circle cx="50" cy="50" r="1.5" fill="${stroke}" />
    `
  },
  {
    id: 'stove_5b',
    name: 'Fogão de Piso 5 Bocas',
    category: 'Cozinha',
    defaultWidth: 76,
    defaultHeight: 65,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="74" height="63" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="53" x2="75" y2="53" stroke="${stroke}" stroke-width="1.5" />
      <rect x="22" y="56" width="32" height="4" rx="1" fill="${stroke}" />
      <circle cx="38" cy="27" r="9" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="16" cy="16" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="60" cy="16" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="16" cy="38" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="60" cy="38" r="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
    `
  },
  {
    id: 'sink_single',
    name: 'Cuba Simples Inox',
    category: 'Cozinha',
    defaultWidth: 50,
    defaultHeight: 40,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="48" height="38" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="6" y="8" width="38" height="26" rx="4" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="25" cy="21" r="3.5" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="25" cy="21" r="1.5" fill="${stroke}" />
      <circle cx="25" cy="4.5" r="2.5" fill="${stroke}" />
      <path d="M 25 4.5 L 25 11" stroke="${stroke}" stroke-width="2" stroke-linecap="round" />
    `
  },
  {
    id: 'sink_double',
    name: 'Cuba Dupla Inox',
    category: 'Cozinha',
    defaultWidth: 80,
    defaultHeight: 45,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="78" height="43" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="9" width="32" height="30" rx="3" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="21" cy="24" r="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="21" cy="24" r="1" fill="${stroke}" />
      <rect x="43" y="9" width="32" height="30" rx="3" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="59" cy="24" r="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="59" cy="24" r="1" fill="${stroke}" />
      <circle cx="40" cy="5" r="2.5" fill="${stroke}" />
      <path d="M 40 5 L 40 12" stroke="${stroke}" stroke-width="2" stroke-linecap="round" />
    `
  },
  {
    id: 'fridge_standard',
    name: 'Geladeira 1 Porta',
    category: 'Cozinha',
    defaultWidth: 70,
    defaultHeight: 70,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="68" height="68" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="62" x2="69" y2="62" stroke="${stroke}" stroke-width="1.5" />
      <rect x="25" y="64" width="20" height="3" rx="1" fill="${stroke}" />
      <line x1="15" y1="15" x2="55" y2="15" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="15" y1="30" x2="55" y2="30" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="15" y1="45" x2="55" y2="45" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
    `
  },
  {
    id: 'fridge_side_by_side',
    name: 'Geladeira Side by Side',
    category: 'Cozinha',
    defaultWidth: 90,
    defaultHeight: 75,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="73" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="45" y1="1" x2="45" y2="74" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="67" x2="89" y2="67" stroke="${stroke}" stroke-width="1" />
      <rect x="33" y="69" width="8" height="3" rx="1" fill="${stroke}" />
      <rect x="49" y="69" width="8" height="3" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'fridge_french_door',
    name: 'Geladeira French Door',
    category: 'Cozinha',
    defaultWidth: 90,
    defaultHeight: 85,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="83" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="45" y1="1" x2="45" y2="65" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="65" x2="89" y2="65" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="30" y="72" width="30" height="5" rx="1.5" fill="${stroke}" />
      <rect x="35" y="58" width="6" height="3" rx="1" fill="${stroke}" />
      <rect x="49" y="58" width="6" height="3" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'oven_tower',
    name: 'Torre Quente (Forno/Micro)',
    category: 'Cozinha',
    defaultWidth: 60,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="6" y="6" width="48" height="44" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="30" cy="28" r="10" fill="none" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="3,2" />
      <rect x="12" y="52" width="36" height="3" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'dishwasher',
    name: 'Lava-Louças Embutir',
    category: 'Cozinha',
    defaultWidth: 60,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="14" x2="59" y2="14" stroke="${stroke}" stroke-width="1.5" />
      <rect x="6" y="4" width="20" height="6" rx="1" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="48" cy="7" r="2.5" fill="${stroke}" />
      <circle cx="40" cy="7" r="2.5" fill="${stroke}" />
      <line x1="8" y1="20" x2="52" y2="20" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="8" y1="36" x2="52" y2="36" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <rect x="16" y="52" width="28" height="3" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'range_hood',
    name: 'Coifa de Parede / Ilha',
    category: 'Cozinha',
    defaultWidth: 90,
    defaultHeight: 50,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="48" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="25" y="8" width="40" height="34" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="45" cy="25" r="11" fill="none" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="3,2" />
      <line x1="1" y1="1" x2="25" y2="8" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="89" y1="1" x2="65" y2="8" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="1" y1="49" x2="25" y2="42" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="89" y1="49" x2="65" y2="42" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
    `
  },

  // ==========================================
  // ÁREA GOURMET
  // ==========================================
  {
    id: 'bbq_masonry',
    name: 'Churrasqueira Alvenaria',
    category: 'Gourmet',
    defaultWidth: 80,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="78" height="58" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="8" y="8" width="64" height="44" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="14" y1="14" x2="66" y2="14" stroke="${stroke}" stroke-width="1" />
      <line x1="14" y1="20" x2="66" y2="20" stroke="${stroke}" stroke-width="1" />
      <line x1="14" y1="26" x2="66" y2="26" stroke="${stroke}" stroke-width="1" />
      <line x1="14" y1="32" x2="66" y2="32" stroke="${stroke}" stroke-width="1" />
      <line x1="14" y1="38" x2="66" y2="38" stroke="${stroke}" stroke-width="1" />
      <line x1="14" y1="44" x2="66" y2="44" stroke="${stroke}" stroke-width="1" />
      <rect x="22" y="16" width="36" height="28" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
    `
  },
  {
    id: 'bbq_gas_steel',
    name: 'Churrasqueira Inox Embutir',
    category: 'Gourmet',
    defaultWidth: 70,
    defaultHeight: 55,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="68" height="53" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="5" width="58" height="38" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="9" y1="11" x2="59" y2="11" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="2,2" />
      <line x1="9" y1="17" x2="59" y2="17" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="2,2" />
      <line x1="9" y1="23" x2="59" y2="23" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="2,2" />
      <line x1="9" y1="29" x2="59" y2="29" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="2,2" />
      <line x1="9" y1="35" x2="59" y2="35" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="2,2" />
      <circle cx="16" cy="48" r="2" fill="${stroke}" />
      <circle cx="28" cy="48" r="2" fill="${stroke}" />
      <circle cx="42" cy="48" r="2" fill="${stroke}" />
      <circle cx="54" cy="48" r="2" fill="${stroke}" />
    `
  },
  {
    id: 'beer_cooler',
    name: 'Cervejeira / Frigobar',
    category: 'Gourmet',
    defaultWidth: 50,
    defaultHeight: 55,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="48" height="53" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="4" width="40" height="42" rx="2" fill="none" stroke="${stroke}" stroke-width="1" />
      <line x1="5" y1="48" x2="45" y2="48" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="18" y="50" width="14" height="2.5" rx="1" fill="${stroke}" />
      <circle cx="25" cy="24" r="9" fill="none" stroke="${stroke}" stroke-width="1" stroke-dasharray="2,2" />
    `
  },
  {
    id: 'wine_cellar',
    name: 'Adega Climatizada',
    category: 'Gourmet',
    defaultWidth: 60,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="6" y1="12" x2="54" y2="12" stroke="${stroke}" stroke-width="1" />
      <line x1="6" y1="22" x2="54" y2="22" stroke="${stroke}" stroke-width="1" />
      <line x1="6" y1="32" x2="54" y2="32" stroke="${stroke}" stroke-width="1" />
      <line x1="6" y1="42" x2="54" y2="42" stroke="${stroke}" stroke-width="1" />
      <circle cx="15" cy="17" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="25" cy="17" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="35" cy="17" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="45" cy="17" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <rect x="20" y="53" width="20" height="3" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'gourmet_island_stools',
    name: 'Ilha Gourmet c/ Banquetas',
    category: 'Gourmet',
    defaultWidth: 180,
    defaultHeight: 80,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="178" height="78" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="55" x2="179" y2="55" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,3" />
      <circle cx="45" cy="67" r="10" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="45" cy="67" r="3" fill="${stroke}" />
      <circle cx="90" cy="67" r="10" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="90" cy="67" r="3" fill="${stroke}" />
      <circle cx="135" cy="67" r="10" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="135" cy="67" r="3" fill="${stroke}" />
    `
  },
  {
    id: 'bistro_table_stools',
    name: 'Mesa Bistrô Alta 2 Banquetas',
    category: 'Gourmet',
    defaultWidth: 70,
    defaultHeight: 70,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <circle cx="35" cy="35" r="28" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="35" cy="8" r="7" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="35" cy="62" r="7" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'sink_gourmet',
    name: 'Pia Gourmet Calha Úmida',
    category: 'Gourmet',
    defaultWidth: 85,
    defaultHeight: 45,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="83" height="43" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="8" width="46" height="30" rx="3" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="28" cy="23" r="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="28" cy="23" r="1.5" fill="${stroke}" />
      <rect x="57" y="8" width="22" height="30" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="62" y1="12" x2="62" y2="34" stroke="${stroke}" stroke-width="1" />
      <line x1="68" y1="12" x2="68" y2="34" stroke="${stroke}" stroke-width="1" />
      <line x1="74" y1="12" x2="74" y2="34" stroke="${stroke}" stroke-width="1" />
      <circle cx="28" cy="4" r="2" fill="${stroke}" />
    `
  },

  // ==========================================
  // LAVANDERIA
  // ==========================================
  {
    id: 'washing_machine',
    name: 'Lava e Seca Frontal',
    category: 'Lavanderia',
    defaultWidth: 60,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="58" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="30" cy="30" r="19" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="30" cy="30" r="14" fill="none" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="1" y1="12" x2="59" y2="12" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="48" cy="6" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <rect x="8" y="4" width="14" height="4" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'washer_top_load',
    name: 'Máquina Abertura Superior',
    category: 'Lavanderia',
    defaultWidth: 65,
    defaultHeight: 65,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="63" height="63" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="6" y="14" width="51" height="45" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="31.5" cy="36.5" r="16" fill="none" stroke="${stroke}" stroke-width="1.5" stroke-dasharray="3,3" />
      <rect x="10" y="4" width="43" height="6" rx="1.5" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="46" cy="7" r="1.5" fill="${stroke}" />
    `
  },
  {
    id: 'laundry_tank',
    name: 'Tanque Lavanderia Simples',
    category: 'Lavanderia',
    defaultWidth: 50,
    defaultHeight: 50,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="48" height="48" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="6" y="10" width="38" height="34" rx="3" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="10" y1="16" x2="40" y2="16" stroke="${stroke}" stroke-width="1" />
      <line x1="10" y1="21" x2="40" y2="21" stroke="${stroke}" stroke-width="1" />
      <line x1="10" y1="26" x2="40" y2="26" stroke="${stroke}" stroke-width="1" />
      <circle cx="25" cy="36" r="2.5" fill="${stroke}" />
      <circle cx="25" cy="5" r="2.5" fill="${stroke}" />
    `
  },
  {
    id: 'laundry_tank_double',
    name: 'Tanque Duplo Lavanderia',
    category: 'Lavanderia',
    defaultWidth: 90,
    defaultHeight: 50,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="48" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="5" y="9" width="37" height="34" rx="3" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="9" y1="15" x2="38" y2="15" stroke="${stroke}" stroke-width="1" />
      <line x1="9" y1="20" x2="38" y2="20" stroke="${stroke}" stroke-width="1" />
      <circle cx="23" cy="34" r="2.5" fill="${stroke}" />
      <rect x="48" y="9" width="37" height="34" rx="3" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="52" y1="15" x2="81" y2="15" stroke="${stroke}" stroke-width="1" />
      <line x1="52" y1="20" x2="81" y2="20" stroke="${stroke}" stroke-width="1" />
      <circle cx="66" cy="34" r="2.5" fill="${stroke}" />
      <circle cx="45" cy="4.5" r="2.5" fill="${stroke}" />
    `
  },

  // ==========================================
  // SALA DE ESTAR & JANTAR
  // ==========================================
  {
    id: 'sofa_2_seater',
    name: 'Sofá 2 Lugares',
    category: 'Sala',
    defaultWidth: 160,
    defaultHeight: 90,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="158" height="88" rx="8" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="2" y="2" width="22" height="86" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="136" y="2" width="22" height="86" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="24" y="2" width="112" height="24" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="24" y="26" width="56" height="58" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="80" y="26" width="56" height="58" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'sofa_3_seater',
    name: 'Sofá 3 Lugares',
    category: 'Sala',
    defaultWidth: 220,
    defaultHeight: 95,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="218" height="93" rx="8" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="2" y="2" width="24" height="91" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="194" y="2" width="24" height="91" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="26" y="2" width="168" height="25" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="26" y="27" width="56" height="64" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="82" y="27" width="56" height="64" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="138" y="27" width="56" height="64" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'sofa_l_chaise',
    name: 'Sofá em L c/ Chaise',
    category: 'Sala',
    defaultWidth: 240,
    defaultHeight: 160,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <path d="M 1 1 L 239 1 L 239 90 L 150 90 L 150 159 L 1 159 Z" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="2" y="2" width="22" height="155" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="216" y="2" width="22" height="86" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="24" y1="24" x2="216" y2="24" stroke="${stroke}" stroke-width="1.5" />
      <rect x="24" y="24" width="62" height="64" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="86" y="24" width="62" height="64" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="148" y="24" width="68" height="64" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="24" y="88" width="124" height="68" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'armchair',
    name: 'Poltrona Individual',
    category: 'Sala',
    defaultWidth: 80,
    defaultHeight: 80,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="78" height="78" rx="8" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="2" y="2" width="16" height="76" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="62" y="2" width="16" height="76" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="18" y="2" width="44" height="20" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="18" y="22" width="44" height="52" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'tv_rack_panel',
    name: 'Rack com Painel TV',
    category: 'Sala',
    defaultWidth: 180,
    defaultHeight: 40,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="178" height="38" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="8" x2="179" y2="8" stroke="${stroke}" stroke-width="1" />
      <line x1="60" y1="8" x2="60" y2="39" stroke="${stroke}" stroke-width="1" />
      <line x1="120" y1="8" x2="120" y2="39" stroke="${stroke}" stroke-width="1" />
      <rect x="35" y="2" width="110" height="4" rx="1" fill="${stroke}" />
    `
  },
  {
    id: 'coffee_table',
    name: 'Mesa de Centro',
    category: 'Sala',
    defaultWidth: 90,
    defaultHeight: 50,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="48" rx="4" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="6" y="6" width="76" height="36" rx="2" fill="none" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
    `
  },
  {
    id: 'dining_table_6',
    name: 'Mesa de Jantar 6 Lugares',
    category: 'Sala',
    defaultWidth: 160,
    defaultHeight: 90,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="25" y="15" width="110" height="60" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="35" y="2" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="67" y="2" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="99" y="2" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="35" y="78" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="67" y="78" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="99" y="78" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'dining_table_round_4',
    name: 'Mesa Jantar Redonda 4 Lugares',
    category: 'Sala',
    defaultWidth: 110,
    defaultHeight: 110,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <circle cx="55" cy="55" r="38" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="42" y="2" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="42" y="98" width="26" height="10" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="2" y="42" width="10" height="26" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="98" y="42" width="10" height="26" rx="2" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },

  // ==========================================
  // QUARTO
  // ==========================================
  {
    id: 'bed_single',
    name: 'Cama Solteiro (90x190)',
    category: 'Quarto',
    defaultWidth: 90,
    defaultHeight: 190,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="188" rx="4" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="18" y="10" width="54" height="30" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="1" y1="52" x2="89" y2="52" stroke="${stroke}" stroke-width="1.5" />
      <path d="M 1 52 Q 45 68 89 52" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'bed_couple',
    name: 'Cama Casal (140x190)',
    category: 'Quarto',
    defaultWidth: 140,
    defaultHeight: 190,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="138" height="188" rx="4" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="12" y="10" width="50" height="32" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="78" y="10" width="50" height="32" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="1" y1="55" x2="139" y2="55" stroke="${stroke}" stroke-width="1.5" />
      <path d="M 1 55 Q 70 72 139 55" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'bed_queen',
    name: 'Cama Queen (160x200)',
    category: 'Quarto',
    defaultWidth: 160,
    defaultHeight: 200,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="158" height="198" rx="4" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="16" y="10" width="56" height="34" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="88" y="10" width="56" height="34" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="1" y1="58" x2="159" y2="58" stroke="${stroke}" stroke-width="1.5" />
      <path d="M 1 58 Q 80 78 159 58" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'bed_king',
    name: 'Cama King (195x200)',
    category: 'Quarto',
    defaultWidth: 195,
    defaultHeight: 200,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="193" height="198" rx="5" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="20" y="10" width="68" height="36" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="107" y="10" width="68" height="36" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="1" y1="60" x2="194" y2="60" stroke="${stroke}" stroke-width="1.5" />
      <path d="M 1 60 Q 97 82 194 60" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'nightstand',
    name: 'Mesa de Cabeceira',
    category: 'Quarto',
    defaultWidth: 45,
    defaultHeight: 45,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="43" height="43" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="12" x2="44" y2="12" stroke="${stroke}" stroke-width="1" />
      <circle cx="22.5" cy="27" r="2" fill="${stroke}" />
    `
  },
  {
    id: 'wardrobe_couple',
    name: 'Guarda-Roupa Casal (240x60)',
    category: 'Quarto',
    defaultWidth: 240,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="238" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="80" y1="1" x2="80" y2="59" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="160" y1="1" x2="160" y2="59" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="52" x2="239" y2="52" stroke="${stroke}" stroke-width="1" />
      <rect x="35" y="54" width="10" height="3" rx="1" fill="${stroke}" />
      <rect x="115" y="54" width="10" height="3" rx="1" fill="${stroke}" />
      <rect x="195" y="54" width="10" height="3" rx="1" fill="${stroke}" />
      <line x1="10" y1="10" x2="70" y2="50" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="70" y1="10" x2="10" y2="50" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
    `
  },

  // ==========================================
  // BANHEIRO & LAVABO
  // ==========================================
  {
    id: 'toilet',
    name: 'Bacia Sanitária c/ Caixa',
    category: 'Banheiro',
    defaultWidth: 40,
    defaultHeight: 65,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="2" y="2" width="36" height="20" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="20" cy="12" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <path d="M 6 22 C 6 48, 10 63, 20 63 C 30 63, 34 48, 34 22 Z" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <ellipse cx="20" cy="40" rx="9" ry="14" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'bathroom_vanity',
    name: 'Bancada c/ Cuba de Apoio',
    category: 'Banheiro',
    defaultWidth: 70,
    defaultHeight: 50,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="68" height="48" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="15" y="10" width="40" height="28" rx="6" fill="none" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <circle cx="35" cy="24" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="35" cy="5" r="2.5" fill="${stroke}" />
      <path d="M 35 5 L 35 12" stroke="${stroke}" stroke-width="2" stroke-linecap="round" />
    `
  },
  {
    id: 'shower_box',
    name: 'Box de Chuveiro Quadrado',
    category: 'Banheiro',
    defaultWidth: 90,
    defaultHeight: 90,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="88" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="1" x2="89" y2="89" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="89" y1="1" x2="1" y2="89" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <circle cx="45" cy="45" r="7" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="45" cy="45" r="2" fill="${stroke}" />
      <rect x="80" y="80" width="8" height="8" rx="1" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'bathtub',
    name: 'Banheira de Imersão',
    category: 'Banheiro',
    defaultWidth: 160,
    defaultHeight: 75,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="158" height="73" rx="16" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="8" y="8" width="144" height="59" rx="12" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="24" cy="37.5" r="3" fill="${stroke}" />
    `
  },

  // ==========================================
  // ESCRITÓRIO & HOME OFFICE
  // ==========================================
  {
    id: 'office_desk_simple',
    name: 'Mesa de Trabalho (120x60)',
    category: 'Escritório',
    defaultWidth: 120,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="118" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="42" y="8" width="36" height="22" rx="1" fill="none" stroke="${stroke}" stroke-width="1" stroke-dasharray="2,2" />
      <circle cx="108" cy="10" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'office_desk_drawers',
    name: 'Mesa c/ Gaveteiro (150x70)',
    category: 'Escritório',
    defaultWidth: 150,
    defaultHeight: 70,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="148" height="68" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="108" y="1" width="41" height="68" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <line x1="108" y1="23" x2="149" y2="23" stroke="${stroke}" stroke-width="1" />
      <line x1="108" y1="46" x2="149" y2="46" stroke="${stroke}" stroke-width="1" />
      <rect x="123" y="10" width="10" height="2" fill="${stroke}" />
      <rect x="123" y="33" width="10" height="2" fill="${stroke}" />
      <rect x="123" y="56" width="10" height="2" fill="${stroke}" />
    `
  },
  {
    id: 'office_desk_l',
    name: 'Mesa em L Diretoria',
    category: 'Escritório',
    defaultWidth: 160,
    defaultHeight: 140,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <path d="M 1 1 L 159 1 L 159 60 L 60 60 L 60 139 L 1 139 Z" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="1" y="100" width="59" height="39" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="145" cy="15" r="3" fill="none" stroke="${stroke}" stroke-width="1" />
    `
  },
  {
    id: 'office_chair',
    name: 'Cadeira Presidente / Ergo',
    category: 'Escritório',
    defaultWidth: 60,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <circle cx="30" cy="30" r="26" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="12" y="24" width="36" height="24" rx="4" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="14" y="6" width="32" height="14" rx="3" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <rect x="4" y="22" width="6" height="22" rx="2" fill="${stroke}" />
      <rect x="50" y="22" width="6" height="22" rx="2" fill="${stroke}" />
    `
  },
  {
    id: 'meeting_table_6',
    name: 'Mesa Reunião 6 Cadeiras',
    category: 'Escritório',
    defaultWidth: 200,
    defaultHeight: 100,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="25" y="15" width="150" height="70" rx="8" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <rect x="75" y="38" width="50" height="24" rx="3" fill="none" stroke="${stroke}" stroke-width="1" />
      <circle cx="50" cy="7" r="6" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="100" cy="7" r="6" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="150" cy="7" r="6" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="50" cy="93" r="6" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="100" cy="93" r="6" fill="none" stroke="${stroke}" stroke-width="1.5" />
      <circle cx="150" cy="93" r="6" fill="none" stroke="${stroke}" stroke-width="1.5" />
    `
  },
  {
    id: 'bookcase',
    name: 'Estante / Livreiro (90x35)',
    category: 'Escritório',
    defaultWidth: 90,
    defaultHeight: 35,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="88" height="33" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="30" y1="1" x2="30" y2="34" stroke="${stroke}" stroke-width="1" />
      <line x1="60" y1="1" x2="60" y2="34" stroke="${stroke}" stroke-width="1" />
      <line x1="1" y1="17" x2="89" y2="17" stroke="${stroke}" stroke-width="1" stroke-dasharray="2,2" />
    `
  },

  // ==========================================
  // MÓDULOS DE MARCENARIA
  // ==========================================
  {
    id: 'cabinet_base',
    name: 'Módulo Balcão (60x60)',
    category: 'Módulos',
    defaultWidth: 60,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="1" x2="59" y2="59" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="1" y1="59" x2="59" y2="1" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="1" y1="56" x2="59" y2="56" stroke="${stroke}" stroke-width="${strokeWidth}" />
    `
  },
  {
    id: 'cabinet_base_double',
    name: 'Módulo Balcão Duplo (120x60)',
    category: 'Módulos',
    defaultWidth: 120,
    defaultHeight: 60,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="118" height="58" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="60" y1="1" x2="60" y2="59" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="1" y1="1" x2="59" y2="59" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="1" y1="59" x2="59" y2="1" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="61" y1="1" x2="119" y2="59" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="61" y1="59" x2="119" y2="1" stroke="${stroke}" stroke-width="1" stroke-dasharray="4,4" />
      <line x1="1" y1="56" x2="119" y2="56" stroke="${stroke}" stroke-width="${strokeWidth}" />
    `
  },
  {
    id: 'cabinet_upper',
    name: 'Módulo Aéreo (60x35)',
    category: 'Módulos',
    defaultWidth: 60,
    defaultHeight: 35,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="58" height="33" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" stroke-dasharray="5,3" />
      <line x1="30" y1="1" x2="30" y2="34" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
    `
  },
  {
    id: 'cabinet_upper_double',
    name: 'Módulo Aéreo Duplo (120x35)',
    category: 'Módulos',
    defaultWidth: 120,
    defaultHeight: 35,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="118" height="33" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" stroke-dasharray="5,3" />
      <line x1="60" y1="1" x2="60" y2="34" stroke="${stroke}" stroke-width="${strokeWidth}" stroke-dasharray="5,3" />
      <line x1="30" y1="1" x2="30" y2="34" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
      <line x1="90" y1="1" x2="90" y2="34" stroke="${stroke}" stroke-width="1" stroke-dasharray="3,3" />
    `
  },
  {
    id: 'slatted_panel',
    name: 'Painel Ripado (100x10)',
    category: 'Módulos',
    defaultWidth: 100,
    defaultHeight: 10,
    getSvgInner: ({ stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => `
      <rect x="1" y="1" width="98" height="8" rx="1" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <line x1="10" y1="1" x2="10" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="20" y1="1" x2="20" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="30" y1="1" x2="30" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="40" y1="1" x2="40" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="50" y1="1" x2="50" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="60" y1="1" x2="60" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="70" y1="1" x2="70" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="80" y1="1" x2="80" y2="9" stroke="${stroke}" stroke-width="1" />
      <line x1="90" y1="1" x2="90" y2="9" stroke="${stroke}" stroke-width="1" />
    `
  }
];

// Injetar função auxiliar renderSvg em cada item para renderização no Drawer / DOM
APPLIANCE_CATALOG.forEach(item => {
  item.renderSvg = ({ width, height, stroke = '#0f172a', strokeWidth = 2, fill = '#ffffff' }) => (
    <svg
      viewBox={`0 0 ${item.defaultWidth} ${item.defaultHeight}`}
      width={width || '100%'}
      height={height || '100%'}
      style={{ overflow: 'visible' }}
      dangerouslySetInnerHTML={{
        __html: item.getSvgInner({ stroke, strokeWidth, fill })
      }}
    />
  );
});

export const getApplianceItem = (id) => APPLIANCE_CATALOG.find(item => item.id === id);
